import { render, staticRenderFns } from "./LoanDetails.vue?vue&type=template&id=50b94fe8"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports